import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './main.css'
import VueCreditCardValidation from 'vue-credit-card-validation'
import EveryActionPlugin from './plugins/every-action/every-action'

import Toast from 'vue-toastification'
import 'vue-toastification/dist/index.css'

import BaseButton from './components/ui/BaseButton.vue'
import BaseTable from './components/ui/BaseTable.vue'
import BasePagination from './components/ui/BasePagination.vue'
import FilterDrawer from './components/ui/FilterDrawer.vue'

import FilterMultiselect from './components/ui/FilterMultiselect.vue'

const app = createApp(App)

app.component('BaseButton', BaseButton)
app.component('BaseTable', BaseTable)
app.component('BasePagination', BasePagination)
app.component('FilterDrawer', FilterDrawer)
app.component('FilterMultiselect', FilterMultiselect)

app.use(store).use(router).use(EveryActionPlugin).use(VueCreditCardValidation).mount('#app')

app.use(Toast, {
  position: 'bottom-right',
  timeout: 3000,
  closeOnClick: true,
  pauseOnFocusLoss: true,
  pauseOnHover: true,
  draggable: true,
  draggablePercent: 0.6,
  showCloseButtonOnHover: false,
  hideProgressBar: true,
  closeButton: 'button',
  icon: true,
  rtl: false,
})
